<template>
    <v-container>
        <div class="text-center my-5">
            <h3>Cupones y descuentos</h3>
        </div>

        <v-row>
            <v-col cols="12" sm="7">
                <v-form @submit.prevent="createCoupon" ref="refAds" lazy-validation>
                    <v-card class="mb-5">
                        <v-card-title>
                            Cupones
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                label="Cupón *"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="name"
                                :error="(errors['name']) ? true : false"
                                :error-messages="(errors['name']) ? errors['name'][0] : ''"
                            ></v-text-field>
                            <v-radio-group v-model="type" row>
                                <v-radio
                                    label="Descuento en porcentaje"
                                    value="percentage"
                                ></v-radio>
                                <v-radio
                                    label="Descuento fijo"
                                    value="fixed"
                                ></v-radio>
                            </v-radio-group>
                            <v-text-field
                                :label="`Monto descuento ${(type=='percentage')?'en porcentaje':'costo fijo'}`"
                                dense
                                outlined
                                type="number"
                                min="0"
                                step="0.1"
                                :rules="[rules.required]"
                                v-model="amount"
                                :error="(errors['amount']) ? true : false"
                                :error-messages="(errors['amount']) ? errors['amount'][0] : ''"
                            ></v-text-field>
                            <v-text-field
                                :label="`Mínimo de compra en ${money} (opcional)`"
                                placeholder="100"
                                dense
                                outlined
                                type="number"
                                v-model="minimum"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="primary"
                                :loading="loading"
                                type="submit"
                            >Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
                <v-simple-table class="mb-10">
                    <template v-slot:default>
                        <thead class="blue-grey darken-4">
                        <tr>
                            <th style="color:white" class="text-left">Cupón</th>
                            <th style="color:white" class="text-left">Tipo</th>
                            <th style="color:white" class="text-left">Monto</th>
                            <th style="color:white" class="text-left">Mínimo de compras en {{ money }}</th>
                            <th style="color:white" class="text-left">Estado</th>
                            <th style="color:white" class="text-right">Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataList" :key="index">
                            <td>{{ item.name }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.minimum }}</td>
                            <td>
                                <v-switch
                                    v-model="item.state"
                                    color="primary"
                                    :label="`${item.state ? 'Activo' :'Inactivo'}`"
                                    @change="updateCoupon($event, item.id)"
                                ></v-switch>
                            </td>
                            <td class="text-right">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="deleteCoupon(item.id)"
                                        >
                                            <v-icon color="grey">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="5">
                <!-- descuentos -->
                <v-card>
                    <v-card-title>
                        Descuentos
                    </v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="saveNewDiscount">
                            <v-radio-group v-model="newDiscount.value">
                                <v-radio
                                    label="Sin descuentos"
                                    value="discount_none"
                                ></v-radio>
                                <v-radio
                                    label="Descuento aplicable a toda la tienda"
                                    value="discount_store"
                                ></v-radio>
                                <v-radio
                                    label="Descuento por categorías"
                                    value="discount_categories"
                                ></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <div v-if="newDiscount.value!='discount_none'">
                                <v-radio-group v-model="newDiscount.type" row>
                                    <v-radio
                                        label="Descuento en porcentaje"
                                        value="percentage"
                                    ></v-radio>
                                    <v-radio
                                        label="Descuento fijo"
                                        value="fixed"
                                    ></v-radio>
                                </v-radio-group>
                                <v-text-field
                                    :label="`Monto descuento ${(newDiscount.type=='percentage')?'en porcentaje':'costo fijo'}`"
                                    placeholder="5"
                                    outlined
                                    dense
                                    type="number"
                                    min="0"
                                    step="0.1"
                                    v-model="newDiscount.discount"
                                ></v-text-field>
                                <v-row no-gutters>
                                    <v-col cols="12" sm="6">
                                        <v-menu
                                            v-model="newDiscount.menu1"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newDiscount.dateInit"
                                                    label="Fecha inicio"
                                                    outlined
                                                    dense
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    disabled
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newDiscount.dateInit"
                                                @input="newDiscount.menu1 = false"
                                                color="primary"
                                                class="ma-0"
                                                locale="es-Bo"
                                                disabled
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="newDiscount.menu2"
                                            :return-value.sync="newDiscount.dateEnd"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newDiscount.dateEnd"
                                                    label="Fecha final"
                                                    outlined
                                                    dense
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newDiscount.dateEnd"
                                                scrollable
                                                color="primary"
                                                class="ma-0"
                                                locale="es-Bo"
                                                :min="obtenerFechaConDiaSiguiente()"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="newDiscount.menu2 = false"
                                                >
                                                    Cancelar
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.dialog.save(newDiscount.dateEnd)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-if="newDiscount.value=='discount_categories'">
                                <v-select
                                    :items="listCategories"
                                    item-value="id"
                                    item-text="name"
                                    label="Categorías"
                                    outlined
                                    dense
                                    multiple
                                    v-model="newDiscount.categories"
                                ></v-select>
                            </div>
                            <div class="text-right">
                                <v-btn
                                    color="primary"
                                    type="submit"
                                    :loading="loading11"
                                >Actualizar</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
                <!-- descuentos END -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            loading11: false,
            name: '',
            type: 'fixed',
            amount: '',
            minimum: '',
            dataList: [],
            // descuentos
            newDiscount: {
                value: 'discount_none',
                type: 'percentage',
                discount: '',
                menu1: false,
                menu2: false,
                dateInit: new Date().toISOString().substr(0, 10),
                dateEnd: '',
                categories: []
            },
            listCategories: [],
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {}
        }
    },
    props: ['slug', 'money'],
    created() {
        this.showCoupons();
        this.getCategories()
        this.getMainData()
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                // console.log(response);
                this.listCategories = response.data
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[12]) {
                    const contentNewDiscount = JSON.parse(response.data[12].content)
                    this.newDiscount.value = contentNewDiscount.value
                    this.newDiscount.type = contentNewDiscount.type_discount
                    this.newDiscount.discount = contentNewDiscount.discount
                    // this.newDiscount.dateInit = contentNewDiscount.date_init
                    this.newDiscount.dateEnd = contentNewDiscount.date_end
                    this.newDiscount.categories = contentNewDiscount.categories
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * save eat local
         */
         async saveNewDiscount() {
            this.loading11 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', 'Descuento general')
            dataForm.append('type', 'gral_discount')
            dataForm.append('value', this.newDiscount.value)
            dataForm.append('type_discount', this.newDiscount.type)
            dataForm.append('discount', this.newDiscount.discount)
            dataForm.append('date_init', this.newDiscount.dateInit)
            dataForm.append('date_end', this.newDiscount.dateEnd)
            dataForm.append('categories', JSON.stringify(this.newDiscount.categories))
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', 'Datos de descuentos actualizado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getMainData()
                }
                this.loading11 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading11 = false
            })
        },
        /**
         * cupones
         */
        async showCoupons() {
            this.dataList = []
            await axios.post(`/list-coupons/${this.slug}`, {})
            .then((response) => {
                // console.log(response);
                response.data.forEach(element => {
                    const tmpEl = JSON.parse(element.content)
                    this.dataList.push({
                        id: element.id,
                        name: element.title,
                        type: tmpEl.type == 'percentage'?'Porcentaje':'Fijo',
                        amount: tmpEl.amount,
                        minimum: tmpEl.minimum?tmpEl.minimum:'-',
                        state: (+tmpEl.state)?true:false
                    })
                });
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * create or edit
         */
        async createCoupon() {
            if (this.$refs.refAds.validate()) {
                this.loading = true
                const formData = new FormData()
                formData.append('name', this.name)
                formData.append('type', this.type)
                formData.append('amount', this.amount)
                formData.append('minimum', this.minimum)
                // formData.append('state', this.state?1:0)
                await axios.post('/admin/coupons', formData)
                .then((response) => {
                    // console.log(response)
                    if (response.data === 'ok') {
                        this.$alert('', 'Cupon creado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        this.$refs.refAds.resetValidation()
                        this.showCoupons();
                    }
                    this.loading = false
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        /**
         * update
         */
        async updateCoupon(e, id) {
            const formData = new FormData()
            formData.append('state', e?1:0)
            formData.append('_method', 'PUT')
            await axios.post(`/admin/coupons/${id}`, formData)
            .then((response) => {
                // console.log(response)
                if (response.data === 'ok') {
                    this.$alert('', 'Cupon actualizado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        },

        /**
         * delete
         */
        async deleteCoupon(id) {
            this.$confirm(
                'Se eliminará permanentemente del sistema, si no esta seguro de esto puede cambiar de estado a inactivo.',
                '¿Eliminar Cupón?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/coupons/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Cupón eliminado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            this.showCoupons()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },

        obtenerFechaConDiaSiguiente() {
            // Obtén la fecha actual
            const fechaActual = new Date();

            // Obtén el día del mes actual
            const diaActual = fechaActual.getDate();

            // Suma 1 al día del mes para obtener el día siguiente
            const diaSiguiente = diaActual + 1;

            // Actualiza la fecha con el día siguiente
            fechaActual.setDate(diaSiguiente);

            // Formatea la fecha en el formato deseado (ISO 8601)
            const fechaConDiaSiguiente = fechaActual.toISOString().substr(0, 10);

            return fechaConDiaSiguiente;
        }
    },
}
</script>
